module.exports = __webpack_public_path__ + "static/img/icon-3-select.ca2edba8.svg";